export const ADDITIONAL_SALES_THEME_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
export const ADDITIONAL_SALES_THEME_IMAGE_NAMES = ['1.png', '2.png', '3.png']

export const getAdditionalSalesThemeImageSrcs = (themeId) =>
  ADDITIONAL_SALES_THEME_IMAGE_NAMES.map(
    (imageName) => `/additional-sales/bg-themes/${themeId}/${imageName}`
  )

export const ADDITIONAL_SALES_HOME_BACKGROUND = '/additional-sales/bg-booking-full.webp'
export const ADDITIONAL_SALES_DETAIL_BACKGROUND = '/additional-sales/bg_main.webp'
